import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Customized loader component displayed in case of unavailable websocket connection.
 * @component
 * @category Components
 * @subcategory Shared
 */

const LogoLoader = () => {
  return (
    <div className='logo-loader-container'>
      <CircularProgress style={{ color: "white", position: "absolute" }} size={180} />
      <img src='/cgm-logo.svg' alt='' width='100px' />
    </div>
  );
};

export default LogoLoader;
